// extracted by mini-css-extract-plugin
export default {"jobApp":"App_jobApp__+XsJu","background-img":"App_background-img__0mb1O","attribution":"App_attribution__vM-q2","btn":"App_btn__BYCvn"};